export default {tooltip:'m-1b3c8819',arrow:'m-f898399f'};